import React from 'react';
import { connect } from 'react-redux';

import { getSecurityContext } from '../../../../../shared/src/selectors/selectors';
import {
  DOCUMENTS_READ,
} from '../../../../../shared/src/security/userRoles';

const BackOfficeAccess = ({ roles, offline }) => !offline && (roles || []).includes(DOCUMENTS_READ) && (
  <a href="/back-office/" className="back-access">
    <i className="ic ic-verrou"/>
    <span>Accédez au back-office</span>
  </a>
);

export default connect(state => ({
  roles: getSecurityContext(state).roles,
  offline: state.appState.offline,
}))(BackOfficeAccess);



// WEBPACK FOOTER //
// ./book/src/commons/components/others/BackOfficeAccess.jsx